const brHostRating = {
  hostRating: {
    label: {
      title: 'Avaliação do hosts',
      comment: 'Comentário',
      rate: 'Avaliar host',
    },
    hint: {
      rating: 'Avaliando com {rating} estrelas',
      about: 'Avalie o atendimento feito pelo host que executou esse serviço.',
    },
    action: {
      sendRating: 'Enviar avaliação',
    },
    messages: {
      success: 'Obrigado por sua avaliação.',
      appointmentNotFound: 'Agendamento não encontrado',
    }
  },
}

export default brHostRating
